<div class="row" style="padding-left:60px; min-height: 100px;">
    <div class="col" style="width: 20%;">        
        <div [ngSwitch]="config.HeaderSelectedLogo">            
            <img *ngSwitchCase="1" style="height:100px;width:100px;"
                name="districtLogo" id="districtLogo" [src]="districtLogo" />
            <img *ngSwitchCase="4" style="height:100px;width:100px;"
                name="alternateDistrictLogo" id="alternateDistrictLogo" [src]="alternateDistrictLogo" />
            <img *ngSwitchCase="2" style="height:100px;width:100px;"
                name="siteLogo" id="siteLogo" [src]="siteLogo" />
            <img *ngSwitchCase="5" style="height:100px;width:100px;"
                name="alternateSiteLogo" id="alternateSiteLogo" [src]="alternateSiteLogo" />
        </div>
    </div>
    <div class="col" style="width: 50%;">
        <div class="row" style="display: flex;justify-content: center;">
            <div *ngIf="config.ShowHeaderSchoolName">
                <div style="font-size: 20px; font-weight: bold;">
                    {{schoolNameTag | mergeField: disableMergeFields: pipeTrigger}}
                </div>
            </div>
        </div>
        <div class="row" style="display: flex;justify-content: center;">
            <div *ngIf="config.ShowHeaderSchoolAddress">
                <div style="font-size: 20px; font-weight: bold;display: flex; justify-content: center;">
                    {{schoolAddressTag | mergeField: disableMergeFields: pipeTrigger}}
                </div>
                <div style="font-size: 20px; font-weight: bold;display: flex; justify-content: center;">
                    {{schoolCityTag | mergeField: disableMergeFields: pipeTrigger}} {{schoolStateTag | mergeField: disableMergeFields: pipeTrigger}} {{schoolZipTag | mergeField: disableMergeFields: pipeTrigger}}
                </div>
                <div style="font-size: 20px; font-weight: bold;display: flex; justify-content: center;">
                    {{schoolPhoneTag | mergeField: disableMergeFields: pipeTrigger}}
                </div>
            </div>
        </div>
    </div>
    <div class="col" style="width: 30%;">

    </div>
</div>
<div class="row" style="padding-left:54px;padding-right:10px;padding-top:20px;font-size: larger">
    {{currentDate | date: 'MM/dd/yy'}}
</div>
<div class="row" style="padding-left:100px;padding-top:76px;font-size: larger">    
    <div class="col" style="width: 50%;">
        <div>
            <div> {{parentNameTag | mergeField: disableMergeFields: pipeTrigger}}</div>
            <div> {{parentAddressStreetTag | mergeField: disableMergeFields: pipeTrigger}}</div>
            <div> {{parentAddressCityTag | mergeField: disableMergeFields: pipeTrigger}}</div>
        </div>
    </div>
    <div class="col" style="width: 50%;">
        <div>
            Student: {{studentNameTag | mergeField: disableMergeFields: pipeTrigger}}
        </div>
    </div>
</div>